import { render, staticRenderFns } from "./VHtmlEditor.vue?vue&type=template&id=04941506&scoped=true"
import script from "./VHtmlEditor.vue?vue&type=script&lang=js"
export * from "./VHtmlEditor.vue?vue&type=script&lang=js"
import style0 from "./VHtmlEditor.vue?vue&type=style&index=0&id=04941506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04941506",
  null
  
)

export default component.exports